module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "naveditor"
    }
  }, [_c('ol', _vm._l((_vm.icons), function(item, index) {
    return _c('li', {
      class: {
        active: _vm.resume.currentTab === index
      },
      on: {
        "click": function($event) {
          _vm.setCurrentTab(index)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + item)
      }
    })])])
  })), _vm._v(" "), _c('ol', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentUser),
      expression: "currentUser"
    }],
    staticClass: "pdf",
    attrs: {
      "id": "pdf"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-pdf"
    }
  })])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentUser),
      expression: "currentUser"
    }],
    staticClass: "save",
    attrs: {
      "id": "save"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-save"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "preview",
    attrs: {
      "id": "preview"
    },
    on: {
      "click": _vm.isPreview
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-preview"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef485ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/NavEditor.vue
// module id = 205
// module chunks = 1